import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { IngredientsServices } from "../../../services";
import { Globals } from "../../../../../globals";
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the IngredientCompPartialIngSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ingredient-comp-partial-ing-selected',
    templateUrl: 'ingredient-comp-partial-ing-selected.html',
})
export class IngredientCompPartialIngSelectedPage {

    //datatable
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public ingredientsServices: IngredientsServices,
        public globals: Globals,
        public translate: TranslateService,) {

    }

    ionViewWillEnter() {
    }

    delete(element) {
        var index = this.ingredientsServices.ingredients_array_tmp.findIndex(x => x[0] == element[0]);
        if (index >= 0) {
            this.ingredientsServices.ingredients_array_tmp.splice(index, 1);
            this.ingredientsServices.ingredients_array_tmp = [...this.ingredientsServices.ingredients_array_tmp];
        }
    }

    clickElement(event) {
        if (event.type == 'click') {
            this.delete(event.row);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-comp-create/ingredient-comp-create-select-ing/ingredient-comp-partial-ing-selected/ingredient-comp-partial-ing-selected.ts